import * as React from 'react';
import {render} from 'react-dom';

import './css/clan-web-pro.css';
import './css/style.css';
import {createStore} from "redux";
import {Provider} from "react-redux";
import {defaultRootState} from "./app/models/states/AppStates";
import {AppReducers} from "./app/reducers/AppReducers";
import MesseAppContainer from "./view/components/MesseAppContainer";
import {AppConfig} from "./app/models/AppConfig";

const domElement: HTMLElement = document.getElementById('JansenMesseApp') as HTMLElement;

// fix for missing Object.assign in IE
if (typeof Object.assign !== 'function') {
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) {
            if (target == null) throw new TypeError('Cannot convert undefined or null to object');

            let to = Object(target);
            for (let index = 1; index < arguments.length; index++) {
                let nextSource = arguments[index];

                if (nextSource != null) {
                    for (let nextKey in nextSource) {
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

defaultRootState.appState.appConfig = AppConfig.mergeWithDefaultConfig({
    linksBaseURL: domElement.getAttribute('linksBaseURL'),
    contentPath: domElement.getAttribute('contentPath'),
    contentXML: domElement.getAttribute('contentXML'),
});

const store = createStore(
    AppReducers.allReducers,
    defaultRootState,
);

const JansenMesseApp = <Provider store={store}>
    <MesseAppContainer/>
</Provider>;

render(
    JansenMesseApp,
    domElement
);
